let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("hvGrC")]).then(() => parcelRequire('d5kQ7'));